module.exports = __webpack_public_path__ + "img/nowe-info.90ccaa95.jpg";